import Timeline from './Timeline';
import type { TimelineSectionProps } from './types';

const TimelineSection = <
  T extends { id: string; title: string; category: string; date: Date | string }
>({
  events = [],
  showSectionBackground = true,
  showHeader = true,
  headerTitle = 'My Journey',
  headerSubtitle = 'A timeline of key moments that have shaped my life and career',
  className = '',
  isLoading = false,
  showFilters = true,
  showSort = true,
  categories,
  renderEvent,
  renderIndicator,
  renderFilter,
  renderShowAllToggle,
  renderSortToggle,
  getEventDate,
  dateFormat,
}: TimelineSectionProps<T>) => {
  const timelineContent = (
    <div className={showSectionBackground ? 'timeline-section' : className}>
      {showHeader && (
        <div className='timeline-section-header'>
          <h2 className='timeline-section-title'>{headerTitle}</h2>
          <p className='timeline-section-subtitle'>{headerSubtitle}</p>
        </div>
      )}
      <div className={showHeader ? 'timeline-section-content' : ''}>
        <Timeline
          events={events}
          isLoading={isLoading}
          showFilters={showFilters}
          showSort={showSort}
          categories={categories}
          renderEvent={renderEvent}
          renderIndicator={renderIndicator}
          renderFilter={renderFilter}
          renderShowAllToggle={renderShowAllToggle}
          renderSortToggle={renderSortToggle}
          getEventDate={getEventDate}
          dateFormat={dateFormat}
        />
      </div>
    </div>
  );

  if (showSectionBackground) {
    return (
      <section id='timeline' style={{ scrollMarginTop: '6rem' }}>
        <div className='timeline-section-background'>
          <div className='timeline-section-content'>{timelineContent}</div>
        </div>
      </section>
    );
  }

  return timelineContent;
};

export default TimelineSection;
